import {useUserContext} from '@hconnect/login'
import {useMemo} from 'react'

import {safetyDefaultValues, hazardAssessmentDefaultValues} from '../config'
import {ChecklistStepFormFields, HazardAssessmentFormFields} from '../containers'
import {type StepsConfig, useWidgetTranslation} from '../hooks'
import {getSafetyValidationSchema, getHazardAssessmentValidationSchema} from '../validators'

export const useTakeFiveStepsConfig = (): StepsConfig => {
  const {t} = useWidgetTranslation()
  const {loggedUser: user} = useUserContext()

  return useMemo(() => {
    return [
      {
        key: 'safety',
        label: t('takeFive.label.checklist'),
        StepFormContent: ChecklistStepFormFields,
        validationSchema: getSafetyValidationSchema({t}),
        defaultValues: safetyDefaultValues
      },
      {
        key: 'hazardAssessment',
        label: t('takeFive.label.hazardAssessment'),
        StepFormContent: HazardAssessmentFormFields,
        validationSchema: getHazardAssessmentValidationSchema({t}),
        defaultValues: {...hazardAssessmentDefaultValues, preparedBy: user?.name}
      }
    ]
  }, [t, user])
}
